// @flow

import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withTranslation } from 'react-i18next';

type Props = {
  offeredCompensation: Object | null,
  variant?: 'grid' | 'typography',
  typographyClass?: string,
  typographyVariant?: string,
  gridClass?: string,
  gridText?: string,
  t: (value: string) => string;
};

class JobCompensation extends React.PureComponent<Props> {
  // duplicates client/src/component/widget/job-compensation.jsx because of separate clients

  formatCurrency(amount: ?number, hasCents: boolean) {
    if (!amount) return null;

    let [dollars, cents] = amount.toFixed(hasCents ? 2 : 0).split('.');
    if (dollars.length > 3){
      let dollarsFormatted = '';
      let count = 1;
      for (let i = dollars.length - 1; i >= 0; i--) {
        dollarsFormatted = dollars[i] + dollarsFormatted;
        if ((count % 3 === 0) && (count !== dollars.length)) {
          dollarsFormatted = ',' + dollarsFormatted;
        }

        count += 1;
      }
      dollars = dollarsFormatted;
    }

    return cents ? `${dollars}.${cents}` : `${dollars}`;
  };

  compensationString(compensationLow: number, compensationHigh: ?number, compensationType: string, hasCents: boolean) {
    let compensationFormatted = '';
    const high = this.formatCurrency(compensationHigh, hasCents);
    const low = this.formatCurrency(compensationLow, hasCents);

    const adornment = compensationType === 'HOURLY' ? this.props.t('compensation.HOURLYAdornment') : this.props.t('compensation.ANNUALAdornment')

    if (low && high && (low !== high)) {
      if (parseFloat(low) > parseFloat(high)) {
        compensationFormatted = `$${high}/${adornment} - $${low}/${adornment}`
      } else {
        compensationFormatted = `$${low}/${adornment} - $${high}/${adornment}`
      }
    } else if (low) {
      // also covers low === high
      compensationFormatted = `$${low}/${adornment}`;
    } else if (high) {
      compensationFormatted = `$${high}/${adornment}`;
    }

    return compensationFormatted;
  };

  doesCompensationHasCents(low: number, high: number) {
    const doesLowHasCents = low ? !Number.isInteger(low) : false;
    const doesHighHasCents = high ? !Number.isInteger(high) : false;

    return doesLowHasCents || doesHighHasCents;
  };

  render() {
    const { offeredCompensation, gridText, gridClass, typographyClass, variant, typographyVariant } = this.props;

    if (!offeredCompensation) {
      return null;
    }
    const { compensationLow, compensationHigh, compensationType } = offeredCompensation
    const hasCents = this.doesCompensationHasCents(compensationLow, compensationHigh);

    if (variant === 'grid') {
      return (
        <Grid container align-items="center" justify="flex-start" className={gridClass}>
          <Typography variant={typographyVariant} className={typographyClass}>{gridText}</Typography>
          <Typography variant={typographyVariant} className={typographyClass} gutterBottom>{this.compensationString(compensationLow, compensationHigh, compensationType, hasCents)}</Typography>
        </Grid>
      )
    }

    return <Typography variant={typographyVariant} className={typographyClass} gutterBottom>{this.compensationString(compensationLow, compensationHigh, compensationType, hasCents)}</Typography>;
  }
}

export default withTranslation()((JobCompensation));
